"use strict";

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function SvgShChartPieSolid(props) {
  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M15.523 8.996H8.544l4.648 4.938a.452.452 0 00.653.021 7.648 7.648 0 002.151-4.4.491.491 0 00-.473-.559zm-.466-2.025A7.308 7.308 0 008.494-.004a.487.487 0 00-.492.511v6.989h6.581a.49.49 0 00.474-.521zM6.588 8.996V1.584a.483.483 0 00-.525-.5A7.379 7.379 0 00.002 8.761a7.354 7.354 0 007.146 7.235 6.731 6.731 0 003.978-1.376.517.517 0 00.046-.753z" })
  );
}

exports.default = SvgShChartPieSolid;
module.exports = exports["default"];